import { render, staticRenderFns } from "./AccreditedCpdsData.vue?vue&type=template&id=0bc59a12"
import script from "./AccreditedCpdsData.vue?vue&type=script&lang=js"
export * from "./AccreditedCpdsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports